export default "__VITE_ASSET__Dyc3iPW6__"